import { render, staticRenderFns } from "./AppActivityLog.vue?vue&type=template&id=2fbb3c5f&scoped=true&"
import script from "./AppActivityLog.vue?vue&type=script&lang=js&"
export * from "./AppActivityLog.vue?vue&type=script&lang=js&"
import style0 from "./AppActivityLog.vue?vue&type=style&index=0&id=2fbb3c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb3c5f",
  null
  
)

export default component.exports